const configs = {
  PUBLIC_URL: process.env.PUBLIC_URL,
  API_URL: process.env.REACT_APP_API_URL,
};

export default configs;
